import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import Customershipping from './Customershipaddress';
import Customerbilling from './Customeraddress';
import AttachmentIcon from '@mui/icons-material/Attachment';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddVendorsbox from './AddVendors';
import Addproducts from './Addproducts';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddPaymentbox from './Addpayments';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import Uploadfile from './Uploadfile';
let strCust=[{title:'Add Vendor',year:'0',rowindex:'-1'}];
let strProd=[{title:'Add Product',year:'0',rowindex:'-1'}];
const strProduct=[];
const strProductdeflt='';


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});





export default class Addvendorpayment extends Component {

  
  constructor(props) {
    super();
	
	 var strdob=new Date();
	 var month="";
	if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}

	
	
	this.state = {veid:'',rowindex:0,
		vendorarrauto:[],vendbilid:'',selectedvendorexchange:[],lefttoalocate:"0.00",
		LedgerData:[],le_id:'',paiddate:Date.now(),
		paiddate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		pmt_paymenttype:'',pmt_reference:'',pmt_amount:'0.00',balance:'0.00',submitbtn:'Save',
		vendorbillData:[],allchecked:false,vbid:'',totalamount:0,outstandingamt:0,discount:"0.00",amountpaid:"0.00",
	errortype:"error",totaloutstanding:"0.00",totalpaid:"0.00",totaldiscount:"0.00",
		payingamount:'',baloutstandingamt:'',displaytrue:false,partpayData:[],previocn:'',vb_file:'',ind:0,
	btndisabled:false,redirect:false,
	vbstatus:"",isdispute:true
	
	}
		 this.onTagsVendorexchange = this.onTagsVendorexchange.bind(this);
		  this.insertvendorParent = this.insertvendorParent;
  } 

 insertvendorParent = (childData) => {
	 this.setState({ veid:childData});		  

 }
 
 
 
updateDonenewParent = (childData) =>{

let strvalues=childData,strind=this.state.ind;
let strarrvalues=strvalues.split('~');

const updatedArrays=[...this.state.vendorbillData];
	
		  updatedArrays[strind].amountdue = strarrvalues[2] ;
		  updatedArrays[strind].discount = strarrvalues[1] ;
		  updatedArrays[strind].amountpaid = strarrvalues[0];
		  
		  this.setState({vendorbillData:updatedArrays});

 this.CalculateTotal(updatedArrays)
}


  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    if (nam === "payingamount") {
      let remaining =
        parseFloat(this.state.outstandingamt ) - parseFloat(val);

      this.setState({
        payingamount: val,
        baloutstandingamt: remaining.toFixed(2), 
      });
    } else {
      this.setState({ [nam]: val });
    }
  };


componentWillMount() {
	
	
	document.title = "Isifol Account - Vendor Payment";

if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			 this.OnloadLedgerBind();
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		

	
	
}
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=14')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
   this.OnloadLedgerBind();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 


onloadVendorBind=(event)=>{

	 axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=vendorextender&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&ve_contactname='+event.target.value)
  .then(resp => { 
  this.setState({vendorarray:resp.data},()=>{
	  
	   var rowsArray = this.state.vendorarray;
	 rowsArray.map((row, i) => {
			 
		 const items = {
         title:row.title,
         year:row.year,
		 rowindex:row.rowindex,
    balance:row.balance
		
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	
		  this.setState({vendorarrauto:strCust})
 });
});
	 
	
}


	onTagsVendorexchange = (event, values) => {
	
		this.setState({
		
		veid:values.year,outstandingamt:values.balance,
		selectedvendorexchange:values},()=>{
			
			
			this.VendorBillGetData(this.state.veid);
		})
		
	
	
       }
 onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({vendbilid:newTextValue},()=>{})
	} 
}
	
	
	OnloadLedgerBind(){
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_isbank=1&le_cmp_id='+localStorage.getItem("ISIcmpid"))
	
    
        .then((response) => {    
     
      this.setState({  LedgerData: response.data,  },()=>{
		  
		let maratonFromApi = this.state.LedgerData.map(rep => {
                            
          return {value: rep.le_id, display:rep.le_code+" - "+ rep.le_displayname}
        });
      
		
        this.setState({
          LedgerData: [{value: '', display: 'Select Ledger'}].concat(maratonFromApi)
        });  
		  
	  });
      })   
    
	
}
	
	
	
	
HandleDatepaid = (date) => {


	  var month="",m="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	  
     this.setState({		
		 paiddate:dayjs(date),
paiddate1:date.getFullYear() + '-' + month + '-' +date.getDate(),

	 })
	
	
  }
	
VendorBillGetData(Vbid){
let strVendor = [];
let strisdispute="8";
if(this.state.isdispute===true)
{
	strisdispute="0";
}
axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=vendorbillcreditgetall&vb_ve_id='+Vbid+'&vb_status='+this.state.vbstatus+'&type=0&vb_cmp_id='+localStorage.getItem("ISIcmpid")+'&vb_isvoiddispute='+strisdispute)
     
  .then(resp => {  	
    if(resp.data.length>0){
		resp.data.map((row,i)=>{
			const items = {
				isseleceted:"0",
				billdate:row.billdate,
				vb_vendorbillno:row.vb_vendorbillno,
			    vb_purchaseorderno:row.vb_purchaseorderno,
				vbp_total:row.vbp_total,
				amountdue:parseFloat(row.vbp_total) -parseFloat(row.outstandingamt),
				outstanding:row.outstandingamt,
				discount:"0.00",
				amountpaid:"0",
				vb_id:row.vb_id,
				type:row.type,
				partpayoutstanding:row.outstandingamt							
			}						
		strVendor.push(items);	
		
	
		});		
		this.setState({  
			  vendorbillData:strVendor,
              vb_id:resp.data[0].vb_id,	});
     }
	 
	  else{
		   this.setState({vendorbillData:[]});
	 }
	 
  
    });
}




onClickSalesSave= (event) => {
	
let optionsVal=this.state.vendorbillData;
let vb_file=this.state.vb_file;



	 if(this.state.veid === "")
	 {		 
		 this.setState({errormessage:"Please Select Vendor",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	



	 if(this.state.le_id === "")
	 {		 
		 this.setState({errormessage:"Please Select Ledeger",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	


 if(this.state.pmt_paymenttype === "")
	 {		 
		 this.setState({errormessage:"Please Select Payment Type",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	

if(this.state. paiddate=== "")
	 {		 
		 this.setState({errormessage:"Please Select Payment Date",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	


 if (this.state.pmt_amount === "" || this.state.pmt_amount === "0.00" ) {
        this.setState({ errormessage: "Please Select Outstanding Bills", erropen: true, });
        window.scrollTo({ top: 0 })
        return false;
    }

	this.setState({btndisabled:true,submitbtn:"Processing..."})


	 
var formData = new FormData();
formData.append('action','Bulkinsert')


formData.append('pmt_amount',this.state.pmt_amount) 			
formData.append('pmt_paymentdate',this.state.paiddate1) 			
formData.append('pmt_ledger_id',this.state.le_id) 			
formData.append('pmt_paymenttype',this.state.pmt_paymenttype) 			
formData.append('pmt_reference',this.state.pmt_reference) 			
formData.append('pmt_type',9) 






let sep1="",optionValues="";


	  optionsVal.forEach(eachval => {
		  
	   if(eachval.isseleceted==="1")
	   {
		   let stramnt=eachval.amountpaid;
 optionValues=optionValues+sep1+String(stramnt).replace("-","")+"~"+eachval.vb_id+"~"+eachval.discount+"~"+eachval.type;
 sep1="`"; 
	   }
		else{
			
			
		
		}
		   
	 
    })


			
formData.append('reciept',optionValues) 	
formData.append('pmt_cmp_id',localStorage.getItem("ISIcmpid"))
 formData.append('userid',localStorage.getItem("ISIuserid"))			
	formData.append('pmt_cu_id',this.state.veid) 

			 axios.post(localStorage.getItem("ISIurl")+"ajaxpayments.php", formData, {
        })	
.then(res => {
				
				
				this.setState({vendorbillData:[],btndisabled:false,pmt_amount:'',pmt_reference:'',le_id:'',vendbilid:'',selectedvendorexchange:[],
				
				submitbtn:'save',errormessage:'Payment Submitted Successfully',errortype:'success',erropen:true,
				outstandingamt:0,
				});
			
});
	
	
	
}

 HandleAllcheckbox=()=>{
	
	  var studArray = this.state.vendorbillData;
	  const updatedArray = [...this.state.vendorbillData];
	  this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
			
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isseleceted = "0" ;
					 
					  updatedArray[j].amountpaid = "0.00";
    updatedArray[j].outstanding = updatedArray[j].amountdue;
					 
					 
				 });
		 }
		 else if(this.state.allchecked===true)
		 {
				
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
				   
				   updatedArray[j].amountpaid = updatedArray[j].amountdue;
				   updatedArray[j].outstanding = "0.00";
				   
				  
				   
				   
				   
		    });
				 
	     }
			 
			this.setState({vendorbillData:updatedArray,},()=>{
				
				
			
				 this.CalculateTotal(updatedArray);
				
				
	
			});
		 
	 }); 
	
	 
} 
   
HandleCheckbox = (id, rowsd) => {
  const updatedArray = [...this.state.vendorbillData];

  if (updatedArray[rowsd].isseleceted === "0") {
    updatedArray[rowsd].isseleceted = "1";
    updatedArray[rowsd].amountpaid = updatedArray[rowsd].amountdue;
    updatedArray[rowsd].outstanding = "0.00";
  } else {
    updatedArray[rowsd].isseleceted = "0";
    updatedArray[rowsd].amountpaid = "0.00";
    updatedArray[rowsd].outstanding = updatedArray[rowsd].amountdue;
  }
    this.setState({ vendorbillData:updatedArray},()=>{this.CalculateTotal(updatedArray)});


};

CalculateTotal(array){
	
  let Totalamount = 0;

    array.forEach(eachval => {
      if (eachval.isseleceted === "1") {
        Totalamount += parseFloat(eachval.amountpaid);
		
      }
    });

    this.setState({ pmt_amount:Totalamount.toFixed(2) });
	
}
 


 
Oncloseicon = () => {
    this.setState({ open: !this.state.open });
  };

handleClose=()=>{
	
	 this.setState({ open: !this.state.open });
};


	

handleVendorInsertpopup= (e) => {
	  this.setState({ veid: 0 },()=>{this.refs.AddVendorsbox.handlevendorClickOpen()});  
	
}

Paymentaddbox(val,va11,val2,val3,val4,rowindex){	

        this.setState({vbid: val,refno:va11,discount:val2,total:val3,amountpaid:val4,ind:rowindex},()=>{this.refs.AddPaymentbox.handleClickOpen()});		
       
      }
	  
	  
	 handledraft=(e)=>{
	this.setState({isdispute: !this.state.isdispute},()=>{
		
		this.VendorBillGetData(this.state.veid);
		
		
	}); 
 }
 
   myChangeHandler = (event) => {
  
  let nam = event.target.name;
  let val = event.target.value;	  
	   this.setState({[nam]: val},()=>{
		   if(	nam=="vbstatus")
{
this.VendorBillGetData(this.state.veid);
}
		   
	   });	

	
   
}

	  
  render() { 


let	granddiscount=0;
let grandtotal=0;
let grandpaid=0;let outstandingamt=0;


	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


return (
  <React.Fragment> 
    <div className="contenttext tabbox">
	
	
      <p>
        <Collapse in={this.state.erropen}>
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.handleErrorclose();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            } 
            severity={this.state.errortype}
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>
      </p>
      
      <ul >
        <li>
          <p><span className="validation">*</span>Vendor</p>
          <p>
            <Autocomplete
              id="free-solo-demo"
              className="txtbox" 
              inputValue={this.state.vendbilid}
              options={this.state.vendorarrauto}   
              onInputChange={this.onInputCustChange}
              onChange={this.onTagsVendorexchange} 
              value={this.state.selectedvendorexchange}
              renderInput={(params) => ( 
                <TextField  
                  placeholder="Search for a vendor" 
                  {...params} 
                  className="txtbox" 
                  onChange={this.onloadVendorBind}  
                  variant="outlined" 
                />
              )}
              getOptionLabel={(option) => option.title || ""}
              renderOption={(props, option) => (
                <React.Fragment>
                  <table width='200%'>
                    <tbody> 
                      {option.rowindex !== "-1" && (
                        <tr {...props}>
                          <td width='10%'>{option.title}</td>
                        </tr>
                      )}
                      {option.rowindex === "-1" && (
                        <tr {...props}>
                          <td width='10%' onClick={this.handleVendorInsertpopup}>
                            <span className='addautoextender'>
                              <AddIcon />
                              {option.title}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </React.Fragment>
              )}
            />
          </p>
          <AddVendorsbox ref="AddVendorsbox" id={0} updatevendor={this.insertvendorParent}/>
          {this.state.outstandingamt !== 0 && (
            <p className="balnacemt">You owe this supplier ${this.state.outstandingamt}.00</p>
          )}
        </li>
        
        <li>
          <p><span className="validation">*</span>Paid from Bank Account</p>
          <p>
            <FormControl className="stadrp">
              <Select
                native 
                fullWidth
                variant="outlined"
                margin="normal"
                
                onChange={this.myChangeHandler}
                id="le_id"
                value={this.state.le_id} 
                className="txtbox"
                name="le_id"
                inputProps={{ tabIndex: "1" }}
              >
                {this.state.LedgerData.map(age => (
                  <option value={age.value}>{age.display}</option>
                ))}
              </Select>
            </FormControl>
          </p> {this.state.balance !== 0 && (
          <p className="balnacemt">Balance {this.state.balance}</p> )}
        </li>
        
        <li>
          <p><span className="validation">*</span>Method</p>
          <p>
            <FormControl className="stadrp">
              <Select
                native
                variant="outlined"
                margin="normal"
                onChange={this.myChangeHandler} 
                className="txtbox"
                id="pmt_paymenttype"
                value={this.state.pmt_paymenttype}
                name="pmt_paymenttype"
                inputProps={{ tabIndex: "6" }}
              >
                <option value="">Select  </option>
                <option value={1}>Cash</option>
                <option value={2}>Check</option>
                <option value={3}>Electronic</option>
                <option value={4}>Credit/Debit Card</option>
                <option value={5}>Paypal</option>
              </Select>
            </FormControl>
          </p>
        </li>
        
        <li>
          <p><span className="validation">*</span>Date Paid</p>
          <p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.paiddate)}
                  className="txtbox"
                  Name="paiddate"
                  onChange={this.HandleDatepaid} 
                  format="MM/DD/YYYY"
                />
              </DemoContainer>
            </LocalizationProvider>
          </p>
        </li>
        
        <li>
          <p>Your Reference (optional)</p>
          <p>
            <TextField 
              variant="outlined"
              margin="normal"
              fullWidth
              value={this.state.pmt_reference}
              id="pmt_reference"
              className="txtbox"
              name="pmt_reference" 
              onChange={this.myChangeHandler}
              placeholder="eg Check Number"
            />
          </p>
        </li>
        
        <li>
          <p>Amount Paid</p>
          <p>
            <TextField 
              variant="outlined"
              margin="normal"
              fullWidth
              value={this.state.pmt_amount}
              id="pmt_amount"
              className="txtbox"
              name="pmt_amount" 
              onChange={this.myChangeHandler}
              placeholder=""
            />
          </p>
        </li>
      </ul>
    </div>
	
<AddPaymentbox ref="AddPaymentbox" id={this.state.vbid} refno={this.state.refno} discount={this.state.discount} total={this.state.total} paid={this.state.amountpaid}  invoiceupdateDone={this.updateDonenewParent}/>	

    <div className="ordtbl">
	
	
	<div className="filterright">
<ul>
<li>
Display:<Select
 native
 variant="outlined" className="txtbox"
 margin="normal"
 fullWidth 
 onChange={this.myChangeHandler}
  id="role"
 value={this.state.vbstatus}
 name="vbstatus"
 inputProps={{tabIndex: "4"}}
    >
<option value={6}>Outstanding</option>
<option value={" "}>All</option>
<option value={2}>Due</option>	

	
</Select>
</li>


<li>

<Checkbox {...label} value={this.state.isdispute}  checked={this.state.isdispute }  onChange={this.handledraft} color="default" />  Exclude Disputed



</li>



</ul>
</div>
	
	<div className="clear"></div>
	
      <Paper >
        <TableContainer >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell width="5%">
                  <Checkbox 
                    checked={this.state.allchecked}
                    onChange={() => { this.HandleAllcheckbox() }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{
                      color: 'white',
                      '&.Mui-checked': { color: 'white' },
                    }}
                  />
                </TableCell>
                <TableCell width="5%"><b>Date</b></TableCell>
                <TableCell width="5%"><b>Number</b></TableCell>
                <TableCell width="5%"><b>Reference</b></TableCell>
                <TableCell width="5%"><b>Type</b></TableCell>
                <TableCell width="5%"><b>Total</b></TableCell>
                <TableCell width="5%"><b>Outstanding</b></TableCell>
                <TableCell width="5%"><b>Discount</b></TableCell>
                <TableCell width="5%"><b>Paid</b></TableCell>
              </TableRow>
            </TableHead>
            
            <TableBody>
             
			 
			  {(this.state.vendorbillData).map((item,index) => {




if(item.outstanding===null || item.amountpaid===null)
{
	item.outstanding=0.00;
	item.amountpaid=0.00;
	
}
else{
	item.outstanding=item.outstanding
	item.amountpaid=item.amountpaid;
	
}

outstandingamt=parseFloat(outstandingamt)+parseFloat(item.outstanding)
granddiscount=(parseFloat(granddiscount)+parseFloat(item.discount)).toFixed(2) 
grandtotal=parseFloat(item.amountpaid) +parseFloat(grandtotal)     

				
           return ( <React.Fragment>
 
 <TableRow key={index} >

  <TableCell>
                    {item.isseleceted === "0" && (
                      <Checkbox
                        onChange={() => { this.HandleCheckbox(item.vb_id, index) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                        sx={{ '&.Mui-checked': { color: 'gray' } }}
                      />
                    )}
                    {item.isseleceted === "1" && (
                      <Checkbox
                        checked
                        onChange={() => { this.HandleCheckbox(item.vb_id, index) }}
                        sx={{ '&.Mui-checked': { color: 'gray' } }}
                      />
                    )}
                  </TableCell>

 <TableCell>{item.billdate}</TableCell>
                  <TableCell>{item.vb_vendorbillno}</TableCell>
                  <TableCell>{item.vb_purchaseorderno}</TableCell>
                  <TableCell>Inv</TableCell>
                  <TableCell>{item.vbp_total}</TableCell>
                  <TableCell>{item.amountdue}</TableCell>

<TableCell  onClick={()=>{this.Paymentaddbox(
						item.vb_id,
						item.vb_purchaseorderno,
						item.discount,
						(item.amountdue),
						item.amountpaid,
						
						
						index)}}>
  {item.vb_id!=="" && (
 
 <Tooltip title="Edit">
 <IconButton aria-label="Edit">
  <div className="secondary">
 <EditIcon 
/>
 </div>
 </IconButton>
 </Tooltip>
  )}
  {item.discount}

</TableCell>
<TableCell onClick={()=>{this.Paymentaddbox(
						item.vb_id,
						item.vb_purchaseorderno,
						item.discount,
						(item.amountdue),
						item.amountpaid,
						index)}}>


  {item.vb_id!=="" && (
 
 <Tooltip title="Edit">
 <IconButton aria-label="Edit">
  <div className="secondary">
  <EditIcon  />
 </div>
 </IconButton>
 </Tooltip>
  )}
{item.amountpaid}
</TableCell>


 </TableRow>

				</React.Fragment>	
				);
					})}	
			  
			 
			  
<TableRow  >
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell colspan={1} align="right">

<TextField name="grandtotal" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={parseFloat(outstandingamt).toFixed(2)}
			 
			
			  inputProps={{tabIndex: "1",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>
<TableCell colspan={1} align="right"><TextField name="granddiscount" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={parseFloat(granddiscount).toFixed(2)}			 
			 
			  inputProps={{tabIndex: "2",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>
						  <TableCell colspan={1} align="right"><TextField name="grandpaid" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={parseFloat(grandtotal).toFixed(2)}
			 
			
			  inputProps={{tabIndex: "3",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>

</TableRow>					  
			  
			  
			  
<TableRow>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>	
<TableCell></TableCell>	
<TableCell>Left to allocate </TableCell>	
 <TableCell colspan={1} align="right"><TextField name="lefttoalocate" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.lefttoalocate}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>
</TableRow>			
			  
			  
			  
			  
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>  
    </div>
    
	
	
   <br/>
  <div className="salesactions">
   <p>
		
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>

   </div>
  
   <div className="clear"></div>
	  
	  
   
  </React.Fragment>
);
  }
}

